import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/AchievementCard.css';

const AchievementCard = ({ userAchievement }) => {
	const { t } = useTranslation();

	const {
		translationKeyTitle,
		translationKeyDescription,
		imageUrl,
		points,
		progress,
		criteriaValue,
		completed
	} = userAchievement;

	const currentCount = progress?.current_count ?? 0;
	const targetCount = criteriaValue?.target_count ?? 0;
	const isCountAchievement = targetCount > 0;
	const notStarted = progress == null;

	return (
		<div className={`achievement-card ${completed ? 'completed' : ''} ${!completed && !notStarted ? 'in-progress' : ''} ${notStarted ? 'not-started' : ''}`}>
			<div className="achievement-content">
				<h3>{t(translationKeyTitle)}</h3>
				<p>{t(translationKeyDescription)}</p>

				{isCountAchievement && !completed && (
					<div className="achievement-progress">
						<p className="progress-numbers">{currentCount} / {targetCount}</p>
						<div className="progress-bar-container">
							<div
								className="progress-bar-fill"
								style={{ width: `${(currentCount / targetCount) * 100}%` }}
							></div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default AchievementCard;